// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hidden_wrapper_3wHE8","content":"Hidden_content_3_eRA"};